import { BaseEntity } from 'yt-ng-framework';

export class KomitentObjekatUpisnoMesto extends BaseEntity {
    constructor(){
        super();
    }
    KomitentID: number = null;
    KomitentObjekatID: number = null;
    NazivUpisnogMesta: string = null;
   
    Deserialize(input: any){
        this.ID = input.ID;
        this.KomitentID = input.KomitentID;
        this.KomitentObjekatID = input.KomitentObjekatID;
        this.NazivUpisnogMesta = input.NazivUpisnogMesta;        
        return this;
    }

    Serialize(input: KomitentObjekatUpisnoMesto){
        return input;
    }
}